module.exports = __webpack_public_path__ + "static/img/help_08book_03.944eedf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_08book_03.png
// module id = 704
// module chunks = 140